import { useState, useCallback, useEffect } from 'react'

// this hook can be used for measuring real height of scaled elements
function useElementHeight({ data = null, liveMeasure = true, delayOnInit = 100, isNodeContentReady = true }) {
  const [height, setHeight] = useState(0)
  const [node, setNode] = useState(null)

  const ref = useCallback(adPreviewNode => {
    setNode(adPreviewNode)
  }, [])

  const measure = useCallback(() => {
    if (node) {
      window.requestAnimationFrame(() => setHeight(node.getBoundingClientRect().height))
    }
  }, [node])

  // This effect will run only once when the component mounts
  useEffect(() => {
    if (node && isNodeContentReady) {
      measure()

      const timer = setTimeout(() => {
        // re-run after delay to measure styles/scaled elements (styles take time to apply)
        measure()
      }, delayOnInit)

      return () => clearTimeout(timer)
    }
  }, [node, delayOnInit, isNodeContentReady, measure])

  useEffect(() => {
    if (node && liveMeasure) {
      window.addEventListener('resize', measure)

      return () => {
        window.removeEventListener('resize', measure)
      }
    }
  }, [node, liveMeasure, measure])

  return { ref, height }
}

export default useElementHeight
